import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-disabledtransfer',
    templateUrl: './disabledtransfer.component.html',
    styleUrls: ['./disabledtransfer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisabledtransferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
